/**
 * Enum de status do Módulo.
 */
// eslint-disable-next-line import/prefer-default-export
export const moduleStatus = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  DISABLED: 'disabled',
  ESTABLISHING_COMMUNICATION: 'establishing-communication',
  UNDER_MAINTENANCE: 'under-maintenance',
  SIMULATION: 'simulation',
  PARTIAL_COMMUNICATION: 'partial-communication',
  INDETERMINATE: 'indeterminate',
};
